module.exports = __webpack_public_path__ + "static/media/legacy-2.4485fc2f.jpg";